export * from 'server/models/PilotAssignment';


// WEBPACK FOOTER //
// ./data/models/PilotAssignment.ts